import { useMemo } from 'react';
import DebateAssignments from './AdminCards/DebateAssignments';
import DebateSubAgenda from './DebateSubAgenda';
import useDebateSpeaker from './useDebateSpeaker';
import useStoredToggle from './useStoredToggle';
import { getDebateTurns } from 'utils/debateTurns';

// Agenda card version of the modal's Sub-agenda and Assignments cards (assignments are read-only here).
export default function DebateCardDetails({ item, meeting, getMeeting, isTimerManager, isLocked }) {
  const turns = useMemo(() => getDebateTurns(item.activity, item.assignedUser), [item.activity, item.assignedUser]);
  const canControl = isTimerManager && !isLocked;
  const { index, select, running } = useDebateSpeaker({ item, meeting, turns, canControl });
  const [showSubAgenda, toggleSubAgenda] = useStoredToggle(item.agendaItemId, 'sub-agenda', false);
  const [showDebaters, toggleDebaters] = useStoredToggle(item.agendaItemId, 'debater-list', false);

  return <div className="debate-card-details mt-2" onClick={event => event.stopPropagation()}>
    <DebateSubAgenda turns={turns} index={index} onSelect={canControl ? select : undefined}
      disabled={running || isLocked} expanded={showSubAgenda} onToggle={toggleSubAgenda} />
    <DebateAssignments collapsible summaryOnly item={item} meeting={meeting} getMeeting={getMeeting} canManage={false}
      expanded={showDebaters} onToggle={toggleDebaters} />
  </div>;
}
